import React from 'react';
import { StatusBar } from 'expo-status-bar';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import AppNavigator from './src/navigation/AppNavigator';
import { AuthProvider } from './src/context/AuthContext';
import { AppProvider } from './src/context/AppContext';
import { PersistentCartProvider } from './src/context/PersistentCartContext';
import { FavoritesProvider } from './src/context/FavoritesContext';

export default function App() {
	console.log('🚀 App: Iniciando aplicación MotoMarketGT');
	return (
		<SafeAreaProvider>
			<StatusBar style="light" backgroundColor="#e74c3c" />
			<AppProvider>
				<AuthProvider>
					<PersistentCartProvider>
						<FavoritesProvider>
							<AppNavigator />
						</FavoritesProvider>
					</PersistentCartProvider>
				</AuthProvider>
			</AppProvider>
		</SafeAreaProvider>
	);
}

import { StyleSheet } from 'react-native';
